import { ReactElement } from "react";
import Chrome from "~/components/Icons/Chrome";
import Firefox from "~/components/Icons/Firefox";
import Opera from "~/components/Icons/Opera";
import { shouldShowBrowserUI, getMidiInstructions } from "~/lib/platform";
import { Dices, Music, Plug, Unlock } from "lucide-react";

export default function Home(): ReactElement {
  return (
    <main className="flex flex-1 px-6 py-6 pb-12">
      <div className="flex flex-col items-center w-full h-full text-center">
        <h1 className="mb-6 mt-2 md:mt-12">
          <img className="block max-h-20 w-auto" src="/logo.png" alt="YO! MIDI" />
        </h1>
        <p className="text-2xl mb-6 md:mb-12">
          A playful MIDI CC scrambler and polyrhythmic pattern generator
        </p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-6 max-w-6xl w-full list-none">
          <li className="bg-gray-800 border border-gray-700 rounded-lg p-3 sm:p-6 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center sm:items-start">
            <Music className="block w-8 h-8 shrink-0 text-[#E91E8C]" />
            <span className="text-center sm:text-left">Press play to start a pattern on our <i className="text-nowrap">Monosynth</i> and <i className="text-nowrap">FM Synth</i> devices</span>
          </li>
          <li className="bg-gray-800 border border-gray-700 rounded-lg p-3 sm:p-6 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center sm:items-start">
            <Dices className="block w-8 h-8 shrink-0 text-[#E91E8C]" />
            <span className="text-center sm:text-left">Open a device and scramble the pattern or the MIDI CCs</span>
          </li>
          <li className="bg-gray-800 border border-gray-700 rounded-lg p-3 sm:p-6 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center sm:items-start">
            <Plug className="block w-8 h-8 shrink-0 text-[#E91E8C]" />
            <span className="text-center sm:text-left">Hook up your favourite MIDI hardware or software, activate them, and scramble away for patch inspiration</span>
          </li>
          <li className="bg-gray-800 border border-gray-700 rounded-lg p-3 sm:p-6 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center sm:items-start">
            <Unlock className="block w-8 h-8 shrink-0 text-[#E91E8C]" />
            <span className="text-center sm:text-left">Create an account to unlock full MIDI capabilities, including locking the params and CCs you want to keep</span>
          </li>
        </ul>
        <p className="mb-12">
          YO! MIDI works with hardware synths, groove boxes, and MIDI-enabled software like DAWs and VSTs
        </p>
        {shouldShowBrowserUI() && (
          <>
            <p className="m-1">
              A MIDI-compatible web browser is required to use the MIDI features
            </p>
            <ul className="inline-flex flex-wrap mb-4 p-0 list-none">
              <li className="w-8 h-8 m-4">
                <a className="text-gray-400 hover:text-white" target="_blank" href="https://www.google.com/chrome/">
                  <Chrome />
                </a>
              </li>
              <li className="w-8 h-8 m-4">
                <a className="text-gray-400 hover:text-white" target="_blank" href="https://www.opera.com/">
                  <Opera />
                </a>
              </li>
              <li className="w-8 h-8 m-4">
                <a className="text-gray-400 hover:text-white" target="_blank" href="https://www.mozilla.org/firefox/">
                  <Firefox />
                </a>
              </li>
            </ul>
          </>
        )}
        {!shouldShowBrowserUI() && (
          <p className="m-1 text-sm text-gray-400 max-w-2xl">
            {getMidiInstructions()}
          </p>
        )}
      </div>
    </main>
  );
}
